import React, { useState, useContext, useEffect } from "react";
import {
   BrowserRouter as Router,
   Routes,
   Route,
   useNavigate,
} from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";
import logo from "../images/evoke.svg";

import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import CopyToClipboardButton from "../components/widgets/CopyToClipboardButton";

// CONTENT BUILDER ROUTES
import Urls from "./Urls";
import UrlsControl from "./UrlsControl";

import LEDWall from "./LEDWall";
import LowerThirds from "./LowerThirds";
import FeatureCards from "./FeatureCards";
import CustomLeaderboard from "./CustomLeaderboard";
import HeadToHead from "./HeadToHead";
import HeadToHeadEditor from "./HeadToHeadEditor";
import PlayerProfiles from "./PlayerProfiles";
import PlayerProfileEditor from "./PlayerProfileEditor";
import RoundByRound from "./RoundByRound";
import RoundByRoundEditor from "./RoundByRoundEditor";
import Decklists from "./Decklists";
import DecklistsInteractive from "./DecklistsInteractive";
import StandingsManager from "./StandingsManager";
import Standings from "./Standings";
import DatabaseManagement from "./DatabaseManagement";
import ConnectedClients from "./ConnectedClients";
import OverlayManager from "./OverlayManager";
import Top8MovingOn from "./Top8MovingOn";
import Top8Bracket from "./Top8";
import Xpression from "./Xpression";

import Downloader from "./Downloader";

import FeatureMatchAdminCombined from "./FeatureMatchAdminCombined";
import FeatureMatchAdmin from "./FeatureMatchAdmin";
import CardsInHandIpad from "./CardsInHandIpad";
import IpadInterface from "./IpadInterface";
import TableHistory from "./TableHistory";

import DraftAdmin from "./DraftAdmin";
import DraftIpad from "./DraftIpad";
import CelebrityDraftAdmin from "./CelebrityDraftAdmin";

import AllPlayerPhotos from "./AllPlayerPhotos";
import AllFlags from "./AllFlags";
import PlayerPhotos from "./PlayerPhotos";
import CardLibrary from "./CardLibrary";
import CardLibraryOverview from "./CardLibraryOverview";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

const drawerWidth = 240;

export default function ContentBuilder(props) {
   let navigate = useNavigate();

   const { window } = props;
   const [mobileOpen, setMobileOpen] = React.useState(false);

   const handleDrawerToggle = () => {
      setMobileOpen(!mobileOpen);
   };

   const drawer = (
      <Box>
         <List>
            {[
               { title: "Downloader", url: "/downloader" }
            ].map((menuItem, index) => (
               <ListItem key={menuItem.title} disablePadding>
                  <ListItemButton
                     onClick={() => navigate("/admin" + menuItem.url)}
                  >
                     <ListItemText primary={menuItem.title} />
                  </ListItemButton>
               </ListItem>
            ))}
         </List>
         <Divider sx={{ backgroundColor: "#444" }} />
         <List>
            {[
               { title: "Decklists", url: "/decklists" },
               { title: "Decklists Interactive", url: "/decklistsinteractive" },

               { title: "Standings Manager", url: "/standingsmanager" },
               { title: "Standings", url: "/standings" },
               { title: "Feature Cards", url: "/featurecards" },
               { title: "Head to Head", url: "/headtohead" },
               { title: "Player Profiles", url: "/playerprofiles" },
               { title: "Round by Round", url: "/roundbyround" },
               { title: "Top 8", url: "/top8" },
               { title: "Bracket", url: "/bracket" },
               { title: "Lower Thirds", url: "/lowerthirds" },
               { title: "LED Wall", url: "/ledwall" },
               { title: "Xpression", url: "/xpression" },
            ].map((menuItem, index) => (
               <ListItem key={menuItem.title} disablePadding>
                  <ListItemButton
                     onClick={() => navigate("/admin" + menuItem.url)}
                  >
                     <ListItemText primary={menuItem.title} />
                  </ListItemButton>
               </ListItem>
            ))}
         </List>
         <Divider sx={{ backgroundColor: "#444" }} />
         <List>
            {[
               { title: "Card Library", url: "/cardlibraryoverview" },
               { title: "Player Photo Assignments", url: "/playerphotos" },
               { title: "All Player Photos", url: "/allplayerphotos" },
               { title: "All Flags", url: "/allflags" },
            ].map((menuItem, index) => (
               <ListItem key={menuItem.title} disablePadding>
                  <ListItemButton
                     onClick={() => navigate("/admin" + menuItem.url)}
                  >
                     <ListItemText primary={menuItem.title} />
                  </ListItemButton>
               </ListItem>
            ))}
         </List>
         <Divider sx={{ backgroundColor: "#444" }} />
         <List>
            {[
               { title: "Card Overlay", url: "/overlaymanager" },
               { title: "Cards In Hand P1", url: "/cardsinhand/1/1" },
               { title: "Cards In Hand P2", url: "/cardsinhand/1/2" },
               { title: "Feature Match Admin", url: "/featurematches" },
               { title: "Table History", url: "/tablehistory" },
               { title: "Draft Admin", url: "/draft/1" },
               { title: "Draft iPad", url: "/draftipad/1" },
               { title: "Sidestage Draft Admin", url: "/celebritydraft" },
               { title: "Feature Match A", url: "/featurematch/1" },
               { title: "Feature Match B", url: "/featurematch/2" },
               { title: "Feature Match C", url: "/featurematch/3" },
               { title: "Feature Match D", url: "/featurematch/4" },
            ].map((menuItem, index) => (
               <ListItem key={menuItem.title} disablePadding>
                  <ListItemButton
                     onClick={() => navigate("/admin" + menuItem.url)}
                  >
                     <ListItemText primary={menuItem.title} />
                  </ListItemButton>
               </ListItem>
            ))}
         </List>
         <Divider sx={{ backgroundColor: "#444" }} />
         <List>
            {[
               { title: "vMix/Mitti URLs", url: "/" },
               { title: "Viewer Control URLs", url: "/control" },
            ].map((menuItem, index) => (
               <ListItem key={menuItem.title} disablePadding>
                  <ListItemButton
                     onClick={() => navigate("/admin" + menuItem.url)}
                  >
                     <ListItemText primary={menuItem.title} />
                  </ListItemButton>
               </ListItem>
            ))}
         </List>
         <Divider sx={{ backgroundColor: "#444" }} />
         <List>
            {[
               { title: "Database Management", url: "/database" },
               // { title: "Connected Clients", url: "/connected-clients" },
            ].map((menuItem) => (
               <ListItem key={menuItem.title} disablePadding>
                  <ListItemButton
                     onClick={() => navigate("/admin" + menuItem.url)}
                  >
                     <ListItemText primary={menuItem.title} />
                  </ListItemButton>
               </ListItem>
            ))}
         </List>
         <Divider sx={{ backgroundColor: "#444" }} />
         <List>
            {[
               { title: "iPad FM A", url: "/ipad/1" },
               { title: "iPad FM B", url: "/ipad/2" },
               { title: "iPad FM C", url: "/ipad/3" },
               { title: "iPad FM D", url: "/ipad/4" },
            ].map((menuItem, index) => (
               <ListItem key={menuItem.title} disablePadding>
                  <ListItemButton
                     onClick={() => navigate("/admin" + menuItem.url)}
                  >
                     <ListItemText primary={menuItem.title} />
                  </ListItemButton>
               </ListItem>
            ))}
         </List>
      </Box>
   );

   const container =
      window !== undefined ? () => window().document.body : undefined;

   return (
      <Box sx={{ display: "flex" }}>
         <CssBaseline />
         <AppBar
            position='fixed'
            sx={{
               width: { sm: `calc(100% - ${drawerWidth}px)` },
               ml: { sm: `${drawerWidth}px` },
               backgroundColor: "#001833",
            }}
         >
            <Toolbar
               sx={{
                  minHeight: 64,
               }}
            >
               <IconButton
                  color='inherit'
                  aria-label='open drawer'
                  edge='start'
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { sm: "none" } }}
               >
                  <MenuIcon />
               </IconButton>
               <img src={logo} style={{ width: 300, marginLeft: 10 }} />
            </Toolbar>
         </AppBar>
         <Box
            component='nav'
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label='mailbox folders'
         >
            <Drawer
               container={container}
               variant='temporary'
               open={mobileOpen}
               onClose={handleDrawerToggle}
               ModalProps={{
                  keepMounted: true,
               }}
               sx={{
                  display: { xs: "block", sm: "none" },
                  "& .MuiDrawer-paper": {
                     boxSizing: "border-box",
                     width: drawerWidth,
                     backgroundColor: "#11151a",
                     color: "#ccc",
                  },
               }}
            >
               <Stack
                  sx={{
                     width: "100%",
                     minHeight: 64,
                     backgroundColor: "#4f0202",
                  }}
                  alignItems='center'
                  justifyContent='center'
               >
                  <Typography variant='h5' component='div'>
                     ADMIN
                  </Typography>
               </Stack>
               {drawer}
            </Drawer>
            <Drawer
               variant='permanent'
               sx={{
                  display: { xs: "none", sm: "block" },
                  "& .MuiDrawer-paper": {
                     boxSizing: "border-box",
                     width: drawerWidth,
                     backgroundColor: "#11151a",
                     color: "#ccc",
                  },
               }}
               open
            >
               <Stack
                  sx={{
                     width: "100%",
                     minHeight: 64,
                     backgroundColor: "#4f0202",
                  }}
                  alignItems='center'
                  justifyContent='center'
               >
                  <Typography variant='h5' component='div'>
                     ADMIN
                  </Typography>
               </Stack>

               {drawer}
            </Drawer>
         </Box>
         <Box
            component='main'
            sx={{
               flexGrow: 1,
               p: 0,
               width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
         >
            <Routes>
               <Route path='/' element={<Urls />} />

               <Route
                  path='/control'
                  element={<UrlsControl parent='admin' />}
               />

               <Route
                  path='/cardsinhand/:tableId/:playerPosition'
                  element={
                     <Box sx={{ pt: 8 }}>
                        <CardsInHandIpad />
                     </Box>
                  }
               />
               <Route path='/ledwall' element={<LEDWall />} />
               <Route path='/lowerthirds' element={<LowerThirds />} />
               <Route path='/featurecards' element={<FeatureCards />} />
               <Route
                  path='/featurematches'
                  element={<FeatureMatchAdminCombined />}
               />
               <Route
                  path='/featurematch/:tableId'
                  element={<FeatureMatchAdmin />}
               />
               <Route path='/tablehistory' element={<TableHistory />} />

               <Route path='/draft/1' element={<DraftAdmin />} />
               <Route
                  path='/draftipad/1'
                  element={
                     <Box sx={{ pt: 8 }}>
                        <DraftIpad />
                     </Box>
                  }
               />
               <Route
                  path='/celebritydraft'
                  element={<CelebrityDraftAdmin />}
               />

               <Route path='/ipad/:tableId' element={<IpadInterface />} />

               <Route path='/overlaymanager' element={<OverlayManager />} />

               <Route
                  path='/standings'
                  element={<CustomLeaderboard parent='admin' />}
               />

               {/* <Route path='/headtohead/:id' element={<HeadToHeadEditor />} /> */}
               <Route
                  path='/headtohead'
                  element={<HeadToHead parent='admin' />}
               />
               <Route path='/headtohead/:id' element={<HeadToHeadEditor />} />
               <Route
                  path='/playerprofiles'
                  element={<PlayerProfiles parent='admin' />}
               />
               <Route
                  path='/playerprofile/:id'
                  element={<PlayerProfileEditor />}
               />
               <Route path='/downloader' element={<Downloader />} />
               <Route path='/decklists' element={<Decklists />} />
               <Route
                  path='/decklistsinteractive'
                  element={<DecklistsInteractive />}
               />
               <Route
                  path='/standings'
                  element={<Standings parent='admin' />}
               />
               <Route path='/standingsmanager/:id' element={<StandingsManager />} />
               <Route
                  path='/standingsmanager'
                  element={<Standings parent='admin' />}
               />
               <Route
                  path='/cardlibraryoverview'
                  element={<CardLibraryOverview />}
               />

               <Route path='/allplayerphotos' element={<AllPlayerPhotos />} />
               <Route path='/allflags' element={<AllFlags />} />
               <Route path='/playerphotos' element={<PlayerPhotos />} />

               <Route
                  path='/roundbyround'
                  element={<RoundByRound parent='admin' />}
               />
               <Route
                  path='/RoundByRound/:id'
                  element={<RoundByRoundEditor />}
               />

               <Route path='/top8' element={<Top8MovingOn parent='admin' />} />

               <Route
                  path='/bracket'
                  element={<Top8Bracket parent='admin' />}
               />

               <Route
                  path='/database'
                  element={<DatabaseManagement parent='admin' />}
               />

               <Route path='/connected-clients' element={<ConnectedClients />} />

               <Route path='/xpression' element={<Xpression />} />
            </Routes>
         </Box>
      </Box>
   );
}
